@if (visible()) {
  <div
    class="v-one-modal__overlay"
    [class.v-one-modal__overlay--closing]="isClosing()"
    (click)="handleBackdropClick($event)"
    (keydown)="handleKeydown($event)"
    role="presentation"
  >
    <div
      [class]="dialogClasses()"
      [class.v-one-modal__dialog--bottom-sheet]="shouldUseBottomSheet()"
      [class.v-one-modal__dialog--closing]="isClosing()"
      [class.v-one-modal__dialog--compact-heading]="hasCompactHeading()"
      [class.v-one-modal__dialog--touch-heading]="hasTouchHeading()"
      [class.v-one-modal__dialog--header-divider]="hasHeaderDivider()"
      role="dialog"
      [attr.aria-labelledby]="'modal-title'"
      [attr.aria-modal]="true"
      tabindex="-1"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()"
    >
      @if (shouldShowDragHandle()) {
        <div class="v-one-modal__drag-handle">
          <div class="v-one-modal__drag-handle-bar"></div>
        </div>
      }

      @if (shouldShowCloseButton()) {
        <button
          class="v-one-modal__close"
          (click)="handleClose()"
          aria-label="Cerrar modal"
          type="button"
        >
          <v-one-icon
            name="close"
            [type]="ICON_TYPE.FILLED"
            className="v-one-modal__close-icon"
          />
        </button>
      }

      @if (config().title) {
        <div
          class="v-one-modal__header"
          [style.--modal-header-align]="headerAlignOverride()"
          [style.--modal-header-text-align]="headerTextAlignOverride()"
        >
          @if (variantConfig().icon) {
            <div class="v-one-modal__icon-container">
              <v-one-icon
                [name]="variantConfig().icon"
                [type]="ICON_TYPE.FILLED"
                className="v-one-modal__icon"
                [style.color]="variantConfig().iconColor"
              />
            </div>
          }

          <div class="v-one-modal__heading">
            <h2 class="v-one-modal__title" id="modal-title">
              {{ config().title }}
            </h2>

            <!-- A hosted component renders its own body, so its subtitle
                 belongs with the title instead of the body. -->
            @if (hasComponent() && config().message) {
              <p class="v-one-modal__subtitle">{{ config().message }}</p>
            }
          </div>
        </div>
      }

      <div class="v-one-modal__content">
        <div
          class="v-one-modal__body"
          [style.--modal-body-padding-x]="bodyPaddingOverride()"
        >
          @if (hasComponent()) {
            <ng-container
              *ngComponentOutlet="component()!; inputs: componentInputs()"
            />
          } @else if (config().message) {
            <p class="v-one-modal__message">{{ config().message }}</p>
          }
        </div>

        @if (!hasComponent() || config().showFooter) {
          <div class="v-one-modal__footer">
            @if (shouldShowReject()) {
              <v-one-button
                [text]="config().rejectText || 'Acción 2'"
                variant="outline"
                (buttonClick)="handleReject()"
                className="v-one-modal__button v-one-modal__button--reject"
              />
            }
            <v-one-button
              [text]="config().acceptText || 'Acción 1'"
              variant="primary"
              (buttonClick)="handleAccept()"
              className="v-one-modal__button v-one-modal__button--accept"
            />
          </div>
        }
      </div>
    </div>
  </div>

  <ngx-spinner
    type="ball-scale-multiple"
    template="<img src='../../../../../../assets/gif/V1-Insight-Icon-for-gif-2.gif' />"
    bdColor="rgba(51,51,51,0.8)"
    [disableAnimation]="true"
  >
    <p style="font-size: 20px; color: #ffffff">{{ 'Loading...' }}</p>
  </ngx-spinner>
}
